import React, { useEffect } from "react";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet.heat";
//import { addressPoints } from "./addressPoints";
import {locations} from './puntoscultivo'
//import { bulletChartMouseClick } from "@syncfusion/ej2-charts";

export default function Map() {
  useEffect(() => {
    //var map = L.map("map").setView([-37.87, 175.475], 12);
    //var map = L.map("map").setView([3.374716, -76.518379], 19);
    var map = L.map("map").setView([5.371689, -71.833868], 19);

    /* L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a id="opens" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map); */

    /* https://stackoverflow.com/questions/9394190/leaflet-map-api-with-google-satellite-layer 
      Note the difference in the "lyrs" parameter in the URL:
      Hybrid: s,h;
      Satellite: s;
      Streets: m;
      Terrain: p; 
      
      Tipos de Mapa
      https://geopois.com/blog/leaflet/leaflet-tiles */
    
    L.tileLayer('https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
      attribution: 
      '&copy; <a id="opens" href="https://www.google.es/maps/preview" target="_blank" rel="noopener noreferrer">Google Maps</a>'
    }).addTo(map);

    /* L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
      attribution: 'Source: Esri, i-cubed, USDA, USGS, AEX,GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',ext:'jpg',
    }).addTo(map); */
    /* const points = addressPoints
      ? addressPoints.map((p) => {
          return [p[0], p[1]];
        })
      : []; */


    const points = locations
      ? locations.map((p) => {
          /* return [p.latitudeE7/10000000, p.longitudeE7/10000000, p.accuracy]; */
          return [p.latitudeE7, p.longitudeE7, p.accuracy];
        })
      : [];

    L.heatLayer(points,{radius:8,max:25,minOpacity:0.3, blur:12,
      //gradient: {0: "#000000",0.2: "#570000",0.4: "#ff0000",0.6: "#ffc800",0.8: "#ffff00",1: "#FFFFFF"}
      gradient:{0.10: 'red', 0.50: '#fc6204', 0.75: '#ffff3b', 1: 'green'}
    }).addTo(map);
  }, []);

  return <div id="map" style={{ height: "87vh" }}></div>;
}
